import React, { useCallback } from 'react';
import { Upload } from 'lucide-react';

interface DocumentUploadProps {
  onFileSelect: (files: FileList) => void;
}

export function DocumentUpload({ onFileSelect }: DocumentUploadProps) {
  const handleDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDrop = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const { files } = e.dataTransfer;
    if (files && files.length > 0) {
      onFileSelect(files);
    }
  }, [onFileSelect]);

  const handleFileSelect = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target;
    if (files && files.length > 0) {
      onFileSelect(files);
    }
  }, [onFileSelect]);

  return (
    <div
      className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-indigo-500 transition-colors duration-200"
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <input
        type="file"
        className="hidden"
        id="file-upload"
        onChange={handleFileSelect}
        accept=".pdf,.jpg,.jpeg,.png"
        multiple
      />
      <label
        htmlFor="file-upload"
        className="cursor-pointer flex flex-col items-center justify-center"
      >
        <Upload className="h-12 w-12 text-gray-400" />
        <p className="mt-2 text-sm text-gray-600">
          Drag files here or click to upload
        </p>
        <p className="mt-1 text-xs text-gray-500">
          Supported formats: PDF, JPG, JPEG, PNG (Max 10MB)
        </p>
      </label>
    </div>
  );
}